<!-- MAIN SECTION  -->
<main class="flex max-mobile:flex-col max-mobile:mt-46px">
	<div
		class="flex flex-col flex-1 ltr:mr-24px rtl:ml-24px max-mobile:rtl:m-0 max-mobile:ltr:m-0"
	>
		<!-- FIRST SECTION  -->
		<section class="p-24px max-mobile:p-0 bg-img rounded-12px mb-12px">
			<p class="text-off-white text-font-14 mb-0">
				{{ 'WALLET.SP_WALLET.TOTALCOUNT' | translate }}
			</p>
			<h1 class="text-off-white text-font-24 font-DIN-bold font-bold mb-[3px]">
				<span>{{
					translate.currentLang == 'en'
						? walletAmount?.currency?.name?.en
						: walletAmount?.currency?.name?.ar
				}}</span
				>{{ walletAmount?.walletAmount }}
			</h1>
			<div class="flex">
				<div>
					<p class="text-off-white text-font-16 mb-[4px]">
						{{ 'WALLET.SP_WALLET.EXPECTED_AMOUNT' | translate }}
					</p>
					<p class="text-off-white text-font-16 font-DIN-bold font-bold">
						<span>{{
							translate.currentLang == 'en'
								? walletAmount?.currency?.name?.en
								: walletAmount?.currency?.name?.ar
						}}</span>
						{{ walletAmount?.expectedAmount }}
					</p>
				</div>
				<div
					class="h-[27px] mx-[24px] w-[1px] bg-off-white flex-nowrap my-[10px]"
				></div>
				<div>
					<p class="text-off-white text-font-16 mb-[4px]">
						{{ 'WALLET.SP_WALLET.PENDING_PAYOUT' | translate }}
					</p>
					<p class="text-off-white text-font-16 font-DIN-bold font-bold">
						<span>{{
							translate.currentLang == 'en'
								? walletAmount?.currency?.name?.en
								: walletAmount?.currency?.name?.ar
						}}</span>
						{{ walletAmount?.holdingPayouts }}
					</p>
				</div>
			</div>
			<div class="flex max-mobile:mb-6px max-mobile:mx-6px">
				<button
					(click)="
						addSubtractFund(
							'empty-wallet-add.svg',
							'add',
							null,
							walletAmount?.currency
						)
					"
					class="bg-off-white py-[10px] px-24px max-mobile:py-[5px] max-mobile:px-12px text-dark-grey rounded-6px ltr:mr-6px rtl:ml-6px"
				>
					<span class="ltr:mr-8px rtl:ml-8px"
						><img
							class="inline-block"
							src="./assets/images/dark-grey-add.svg"
							alt=""
					/></span>
					{{ 'WALLET.SP_WALLET.ADD_FUND' | translate }}
				</button>
				<button
					(click)="
						addSubtractFund(
							'wallet-minus.svg',
							'sub',
							walletAmount.walletAmount,
							walletAmount?.currency
						)
					"
					class="bg-transparent py-[10px] px-24px max-mobile:py-[5px] max-mobile:px-12px text-off-white rounded-6px border border-[#D9DBE9]"
				>
					<span class="ltr:mr-8px rtl:ml-8px"
						><img
							class="inline-block"
							src="./assets/images/minus-white.svg"
							alt=""
					/></span>
					{{ 'WALLET.SP_WALLET.SUBTRACT_FUND' | translate }}
				</button>
			</div>
		</section>
		<!-- FIRST SECTION  -->
		<section class="bg-off-white rounded-12px p-24px mb-12px">
			<h1 class="text-dark-grey text-font-18 font-DIN-bold font-bold mb-16px">
				{{ 'WALLET.SP_WALLET.PAYOUT_METHODS' | translate }}
			</h1>
			<div class="bg-[#F5F5F5] rounded-12px mb-3">
				<div
					*ngFor="let item of walletAmount?.payoutMethods; let indx = index"
					class=" py-12px px-16px {{
						indx + 1 != walletAmount?.payoutMethods?.length
							? 'border-b-[1px] border-secondry-color-Gray'
							: ''
					}}"
				>
					<div *ngIf="walletAmount?.payoutMethods?.length">
						<div class="flex justify-between">
							<div class="flex items-start">
								<img
									class="ltr:mr-16px rtl:ml-16px"
									src="assets/images/{{
										item?.payoutMethod?.id == 1
											? 'bank'
											: item?.payoutMethod?.id == 2
											? 'Fawri'
											: 'instapay'
									}}.{{ item?.payoutMethod?.id == 1 ? 'png' : 'svg' }}"
									alt=""
								/>
								<div *ngIf="item?.payoutMethod?.id == 1">
									<p class="text-medium-gray">
										{{
											translate.currentLang === 'ar'
												? item?.payoutMethod?.nameAr
												: item?.payoutMethod?.nameEn
										}}
									</p>
									<p>{{ item?.bankName }}</p>
									<p>{{ item?.accountName }}</p>
									<p>{{ item?.accountNumber }}</p>
								</div>

								<div *ngIf="item?.payoutMethod?.id == 2">
									<p class="text-medium-gray">
										{{
											translate.currentLang === 'ar'
												? item?.payoutMethod?.nameAr
												: item?.payoutMethod?.nameEn
										}}
									</p>
									<p>{{ item?.fawryAccount }}</p>
								</div>

								<div *ngIf="item?.payoutMethod?.id == 3">
									<p class="text-medium-gray">
										{{
											translate.currentLang === 'ar'
												? item?.payoutMethod?.nameAr
												: item?.payoutMethod?.nameEn
										}}
									</p>
									<p>{{ item?.instapayAccount }}</p>
								</div>
							</div>
							<mat-checkbox
								*ngIf="item?.isDefault"
								class="m-[8px]"
								[disabled]="true"
								[checked]="item?.isDefault"
							></mat-checkbox>
						</div>
					</div>
				</div>
			</div>
			<div
				class="text-center m-auto text-dark-grey text-font-16"
				*ngIf="!walletAmount?.payoutMethods?.length"
			>
				{{ 'PAYOUT.PAYOUT_LIST.INFO_MISSING' | translate }}
			</div>
		</section>
		<!-- SECOND SECTION  -->
		<app-wallet-history-list [refresh]="refresh"></app-wallet-history-list>
		<!-- SECOND SECTION  -->
	</div>
	<!-- THIRD SECTION  -->
	<app-sp-payout-list class="flex-1"></app-sp-payout-list>
	<!-- THIRD SECTION  -->
</main>
<!-- MAIN SECTION  -->
